var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._m(0),_c('div',{staticClass:"kefu fs18 col-3"},[_vm._v("客服电话："+_vm._s(_vm.kefu))])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"g-head-box flex-box col-3 mb30"},[_c('div',{staticClass:"fs18"},[_vm._v("联系客服")])])
}]

export { render, staticRenderFns }